// extracted by mini-css-extract-plugin
module.exports = {"link-preview":"bank_link-preview__1JH0l","link-sbo__icon":"bank_link-sbo__icon__109RX","overview":"bank_overview__1vWzS"};